import { Col, Row, Input } from 'antd';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetLocalStorageValue } from '../../../../_config/adapters/local-storage/get-local-storage-value.adapter';
import CustomCard from '../../../../v2-components/Antd/Card';
import CustomLink from '../../../../v2-components/Antd/Link';
import CustomPagination from '../../../../v2-components/Antd/Pagination';
import LoadingPage from '../../../../v2-components/LoadingPage';
import { formatedDate } from './handle/formated-date.handle';
import { Service } from './service';
import { TYPE_RETIREMENT } from './constants/type-retirement.constant';
import './style.scss';
import ScrollToTop from '../../../../v2-components/ScrollToTop';

export default function ProfileShoppingHisgoryPage() {
	const history = useHistory();
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(true);
	const [orderHistory, setOrderHistory] = useState();
	const [pagination, setPagination] = useState();
	const [currentPage, setCurrentPage] = useState(1);
	const [searchId, setSearchId] = useState('');
	const { token } = GetLocalStorageValue('userMainInfo');

	const { Search } = Input;

	useEffect(() => {
		const params = queryString.parse(location.search);
		console.log('params!', params);
		const page = params.page || 1;
		new Service()
			.getPurchaseHistory(token, page)
			.then((response) => {
				setOrderHistory(response.data.data);
				setPagination(response.data);

				setIsLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [token, location.search]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
		const queryParams = { page };
		history.push({ search: queryString.stringify(queryParams) });
	};

	if (isLoading) {
		return <LoadingPage />;
	}

	const onSearch = (value) => {
		setSearchId(value.trim());
	};

	// Filter orders based on the searchId
	const filteredOrders = searchId
		? orderHistory.filter((item) => item.trx_id.toString().includes(searchId))
		: orderHistory;

	return (
		<>
			<ScrollToTop />
			<Row justify="center" className="shopping-history-content">
				<Col md={24} xs={22}>
					<Row justify="left">
						<h3>Historial de compras</h3>
					</Row>
					<Row justify="space-between" align="bottom">
						<CustomLink className={'link-primary'} to="/profile-info">
							Volver
						</CustomLink>
						<Search
							placeholder="N° de orden"
							allowClear
							style={{ width: 160 }}
							onSearch={onSearch}
						/>
					</Row>
					<br></br>

					<Row gutter={[20, 10]} justify="start">
						{filteredOrders.map((item, index) => {

							return (
								<React.Fragment key={`card-${index}`}>
									<Col key={`card-${index}`} md={12} xs={24}>
										<CustomCard
											onClick={() => {
												history.push(`/profile-info/shopping-history/${item._id}/${item.trx_id}`);
											}}
											title={`Orden n° ${item.trx_id}`}
											className={'card-primary pointer'}
											extra={<p>{TYPE_RETIREMENT[item?.info?.type_retirement]}</p>}
										>
											<Row justify="space-between" className={'card-row'}>
												<Col>
													<span className={'data'}>Farmacia: </span>{item.root_pharmacy}
												</Col>
												<Col>
													<p className={'date'}>{formatedDate(item.createdAt)}</p>
												</Col>
											</Row>

											<Row justify="left" className={'card-row'}>
												<Col xs={24}>
													<span className={'data'}>Nombre: </span>{item.info.first_name} {item.info.last_name}
												</Col>
											</Row>
											<Row justify="left">

												<Col md={8} xs={24}>
													<span className={'data'}>Monto: </span> ${item.total}
												</Col>
											</Row>
										</CustomCard>
										<br></br>
									</Col>
								</React.Fragment>
							);
						})}
					</Row>
					<Row justify="center" align="middle" className={'custom-pagination'} style={{ flexDirection: 'column' }}>
						<Row justify="center" style={{ width: '100%' }}>
						<CustomPagination
							className={'pagination-default'}
							current={currentPage}
							total={pagination?.totalItems}
							pageSize={pagination?.itemsPerPage}
							onChange={handlePageChange} />
						</Row>
						<Row justify="start" style={{ width: '100%'}}>
							<span className="ph-elastic-right-side-paging-info-title">
								Mostrando:{' '}
								<strong className="ph-elastic-right-side-paging-info-subtitle">
									{pagination?.beginPage} - {pagination?.endPage}
								</strong>{' '}
								de un Total:{' '}
								<strong className="ph-elastic-right-side-paging-info-subtitle">
									{pagination?.totalItems}
								</strong>
							</span>
						</Row>
					</Row>
				</Col>
			</Row>
		</>
	);
}
